import React from 'react';
import { isBrowser } from "react-device-detect";
import { makeStyles, ListItem, ListItemIcon, ListItemText, List, Hidden, Typography } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import HistoryIcon from '@material-ui/icons/History';
import CheckIcon from '@material-ui/icons/Check';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LaptopIcon from '@material-ui/icons/Laptop';
import SettingsIcon from '@material-ui/icons/Settings';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TranslateIcon from '@material-ui/icons/Translate';
import customAxios from "../API/customAxios";
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { getApproves } from '../LeaveApproval/api/ApprovalAPI';
import { getCompLeaveApproves } from '../CompLeaveReqsApproval/api/ApprovalAPI';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper,
	},
	subModule: {
		marginLeft: theme.spacing(10),
	},
	selectedItem: {
		fontWeight: 'bold',
	},
	spaceBetween: {
		width: '100%',
		display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
	},
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		right: -11,
		top: 7,
		padding: '0 4px',
		fontSize: '0.9rem',
		minWidth: '16px',
		height: '16px',
	},
}));

const initialState = {
	application: false,
	myRequest: false,
	leaveApproval: false,
	hrAdmin: false,
};

export default function NestedList() {
	const intl = useIntl();
	const classes = useStyles();
	const history = useHistory();
	const isOfficeHourDuty = localStorage.getItem('staff_duty') === window.global.officeHours;
	const [showAdmin, setShowAdmin] = React.useState();
	const [language, setLanguage] = React.useState(localStorage.getItem('locale') || 'en');
	const [translate, setTranslate] = React.useState();
	const [selectedIndex, setSelectedIndex] = React.useState(0);
	const [collapseStates, setCollapseStates] = React.useState(initialState);
	const [numberOfPendingApprovals, setNumberOfPendingApprovals] = React.useState();

	React.useEffect(() => {
		let isMounted = true;

		async function fetchData() {
			try {
				let isHrAdminRole = JSON.parse(localStorage.getItem('isHrAdminRole'));

				if (isHrAdminRole === null) {
					const permissionResponse = await customAxios.get('/get_permission');
					if (isMounted) {
						isHrAdminRole = permissionResponse.data.hr_admin === true;
						localStorage.setItem('isHrAdminRole', isHrAdminRole);
						setShowAdmin(isHrAdminRole);
					}
				} else {
					setShowAdmin(isHrAdminRole);
				}
			} catch (error) {
				console.log('Error fetching user data and permission:', error);
			}
		}
		fetchData();

		return () => {
			isMounted = false;
		};
	}, []);

	React.useEffect(() => {
		const pathName = window.location.pathname;
		if (pathName === '/home' || pathName === '/myteam') {
			setCollapseStates(initialState);
		} else {
			const storedStates = {
				application: JSON.parse(localStorage.getItem('isApplicationOpen')),
				myRequest: JSON.parse(localStorage.getItem('isMyRequestOpen')),
				leaveApproval: JSON.parse(localStorage.getItem('isLeaveApprovalOpen')),
				hrAdmin: JSON.parse(localStorage.getItem('isHRAdminOpen')),
			};
			setCollapseStates(storedStates);
		}
		const storedIndex = parseInt(localStorage.getItem('selectedIndex'), 10);
		setSelectedIndex(storedIndex || 0);

		const newLang = language === 'en' ? intl.formatMessage({ id: 'bar.english' }) : intl.formatMessage({ id: 'bar.chinese' });
		setTranslate(newLang);
	}, []);

    React.useEffect(() => {
		let isMounted = true;
		async function fetchData() {
			try {
				const [approvesResponse, compLeavesResponse] = await Promise.all([
					getApproves(true),
					getCompLeaveApproves(true),
				]);

				if (isMounted) {
					if (approvesResponse.status === 200 && compLeavesResponse.status === 200) {
						setNumberOfPendingApprovals(approvesResponse.data.count + compLeavesResponse.data.count);
					}
				}
			} catch (error) {
				console.error("Failed to fetch data:", error);
			}
		}
		fetchData();
		return () => {
			isMounted = false;
		};
    }, []);

	const handleChangeLanguage = () => {
		const newLang = language === 'en' ? 'zh' : 'en';
		setLanguage(newLang);
		localStorage.setItem('locale', newLang);
		history.go(0);
	};

	const linkToPage = (path) => {
		history.push(path);
	};

	const handleNonCollapseClick = () => {
		setCollapseStates(initialState);
	};

	const handleCollapseClick = (index, path) => {
		const isApplication = path === '/leave_application';
		const isMyLeave = path === '/myleave';
		const isLeaveApproval = path === '/leave_approval';
		const isHRAdmin = path === '/employee_record_mgt';

		setCollapseStates(prevState => {
			const newStates = {
				...prevState,
				application: isApplication ? !prevState.application : false,
				myRequest: isMyLeave ? !prevState.myRequest : false,
				leaveApproval: isLeaveApproval ? !prevState.leaveApproval : false,
				hrAdmin: isHRAdmin ? !prevState.hrAdmin : false,
			};
	
			localStorage.setItem('selectedIndex', index.toString());
			localStorage.setItem('isApplicationOpen', isApplication ? JSON.stringify(!prevState.application) : 'false');
			localStorage.setItem('isMyRequestOpen', isMyLeave ? JSON.stringify(!prevState.myRequest) : 'false');
			localStorage.setItem('isLeaveApprovalOpen', isLeaveApproval ? JSON.stringify(!prevState.leaveApproval) : 'false');
			localStorage.setItem('isHRAdminOpen', isHRAdmin ? JSON.stringify(!prevState.hrAdmin) : 'false');
	
			linkToPage(path);
	
			return newStates;
		});
	};

	const handleListItemClick = (index, path) => {
		localStorage.setItem('selectedIndex', index.toString());
		localStorage.setItem('isApplicationOpen', JSON.stringify(collapseStates.application));
		localStorage.setItem('isMyRequestOpen', JSON.stringify(collapseStates.myRequest));
		localStorage.setItem('isLeaveApprovalOpen', JSON.stringify(collapseStates.leaveApproval));
		localStorage.setItem('isHRAdminOpen', JSON.stringify(collapseStates.hrAdmin));

		linkToPage(path);
	};

	return (
		<List>
			{/* home */}
			<ListItem 
				onClick={() => {
					handleNonCollapseClick()
					handleListItemClick(0, '/home')
				}} 
				button 
				key="home"
				selected={selectedIndex === 0}
			>
				<ListItemIcon>
					<HomeIcon style={{ color: '#232f3e' }} />
				</ListItemIcon>
				<ListItemText
					disableTypography
					primary={
						<Typography className={`${selectedIndex === 0 ? classes.selectedItem : ''}`}>
							{intl.formatMessage({ id: 'navigation.home' })}
						</Typography>
					}
				/>
			</ListItem>

			{/* Application */}
			{!showAdmin ? (
				<>
					<ListItem 
						onClick={() => {
							handleCollapseClick(1, '/leave_application')
						}} 
						button 
						key="application"
					> 
						<ListItemIcon>
							<EditIcon style={{ color: '#232f3e' }} />
						</ListItemIcon>
						<ListItemText
							disableTypography
							primary={
								<Typography className={`${selectedIndex === 1 || selectedIndex === 2 ? classes.selectedItem : ''}`}>
									{intl.formatMessage({ id: 'navigation.application' })}
								</Typography>
							}
						/>
						{collapseStates.application ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={collapseStates.application} timeout="auto" unmountOnExit key="application_collapse">
						<List component="div" disablePadding>
							<ListItem 
								onClick={() => {
									handleListItemClick(1, '/leave_application')
								}} 
								button 
								key="leave_application_item"
								selected={selectedIndex === 1}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 1 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.leave' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
							<ListItem 
								onClick={() => {
									handleListItemClick(2, '/comp_leave_request')
								}} 
								button 
								key="comp_leave_request_item"
								selected={selectedIndex === 2}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 2 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.ot_compensation' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
						</List>
					</Collapse>
				</>
			) : (
				<>
					{!showAdmin && (
						<ListItem 
							onClick={() => {
									handleListItemClick(1, '/leave_application')
								}} 
							button 
							key="leave_application"
							selected={selectedIndex === 1}
						>
							<ListItemIcon>
								<EditIcon style={{ color: '#232f3e' }} />
							</ListItemIcon>
							<ListItemText
								disableTypography
								primary={
									<Typography className={`${selectedIndex === 1 ? classes.selectedItem : ''}`}>
										{intl.formatMessage({ id: 'navigation.leave_applicaion' })}
									</Typography>
								}
							/>
						</ListItem>
					)}
				</>
			)}

			{/* My Requests */}
			{!showAdmin ? (
				<>
					<ListItem 
						onClick={() => {
							handleCollapseClick(3, '/myleave')
						}} 
						button 
						key="my_requests"
					> 
						<ListItemIcon>
							<HistoryIcon style={{ color: '#232f3e' }} />
						</ListItemIcon>
						<ListItemText
							disableTypography
							primary={
								<Typography className={`${selectedIndex === 3 || selectedIndex === 4 ? classes.selectedItem : ''}`}>
									{intl.formatMessage({ id: 'navigation.my_requests' })}
								</Typography>
							}
						/>
						{collapseStates.myRequest ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={collapseStates.myRequest} timeout="auto" unmountOnExit key="my_requests_collapse">
						<List component="div" disablePadding>
							<ListItem 
								onClick={() => 
									handleListItemClick(3, '/myleave')
								} 
								button 
								key="my_leave_item"
								selected={selectedIndex === 3}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 3 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.leave' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
							<ListItem 
								onClick={() => 
									handleListItemClick(4, '/myCompleaveReqs')
								}
								button 
								key="my_comp_leave_request_item"
								selected={selectedIndex === 4}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 4 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.ot_compensation' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
						</List>
					</Collapse>
				</>
			) : (
				<>
					{!showAdmin && (
						<ListItem 
							onClick={() => 
								handleListItemClick(3, '/myleave')
							}
							button 
							key="my_leave"
							selected={selectedIndex === 3}
						>
							<ListItemIcon>
								<HistoryIcon style={{ color: '#232f3e' }} />
							</ListItemIcon>
							<ListItemText
								disableTypography
								primary={
									<Typography className={`${selectedIndex === 3 ? classes.selectedItem : ''}`}>
										{intl.formatMessage({ id: 'navigation.myleave' })}
									</Typography>
								}
							/>
						</ListItem>
					)}
				</>
			)}

			{/* Approval */}
			<>
				<ListItem 
					onClick={() => {
						handleCollapseClick(5, '/leave_approval')
					}} 
					button 
					key="approval"
				> 
					<ListItemIcon>
						<CheckIcon style={{ color: '#232f3e' }} />
					</ListItemIcon>
					<div className={classes.spaceBetween}>
						{collapseStates.leaveApproval ? (
							<ListItemText
								disableTypography
								primary={
									<Typography className={`${selectedIndex === 5 || selectedIndex === 6 ? classes.selectedItem : ''}`}>
										{intl.formatMessage({ id: 'navigation.approval' })}
									</Typography>
								}
							/>
						) : (
							<StyledBadge 
								badgeContent={numberOfPendingApprovals} 
								color="error"
							>
								<ListItemText
									disableTypography
									primary={
										<Typography className={`${selectedIndex === 5 || selectedIndex === 6 ? classes.selectedItem : ''}`}>
											{intl.formatMessage({ id: 'navigation.approval' })}
										</Typography>
									}
								/>
							</StyledBadge>
						)}
						{collapseStates.leaveApproval ? <ExpandLess /> : <ExpandMore />}
					</div>
				</ListItem>
				<Collapse in={collapseStates.leaveApproval} timeout="auto" unmountOnExit key="approval_collapse">
					<List component="div" disablePadding>
						<ListItem 
							onClick={() => 
								handleListItemClick(5, '/leave_approval')
							}
							button 
							key="leave_approval_item"
							selected={selectedIndex === 5}
						>
							<div className={classes.subModule}>
								<StyledBadge 
									badgeContent={numberOfPendingApprovals} 
									color="error"
								>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 5 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.pending' })}
											</Typography>
										}
									/>
								</StyledBadge>
							</div>
						</ListItem>
						<ListItem 
							onClick={() => 
								handleListItemClick(6, '/approval_history')
							}
							button 
							key="comp_leave_request_approval_item"
							selected={selectedIndex === 6}
						>
							<div className={classes.subModule}>
								<ListItemText
									disableTypography
									primary={
										<Typography className={`${selectedIndex === 6 ? classes.selectedItem : ''}`}>
											{intl.formatMessage({ id: 'navigation.history' })}
										</Typography>
									}
								/>
							</div>
						</ListItem>
					</List>
				</Collapse>
			</>

			{/* My Team */}
			<ListItem 
				onClick={() => {
					handleNonCollapseClick()
					handleListItemClick(7, '/myteam')
				}}
				button 
				key="my_team"
				selected={selectedIndex === 7}
			>
				<ListItemIcon>
					<SupervisorAccountIcon style={{ color: '#232f3e' }} />
				</ListItemIcon>
				<ListItemText
					disableTypography
					primary={
						<Typography className={`${selectedIndex === 7 ? classes.selectedItem : ''}`}>
							{intl.formatMessage({ id: 'navigation.myteam' })}
						</Typography>
					}
				/>
			</ListItem>

			{/* HR Admin */}
			{showAdmin && isBrowser && (
				<>
					<ListItem 
						button 
						onClick={() => {
							handleCollapseClick(8, '/employee_record_mgt')
						}} 
						key="hr_admin"
					>
						<ListItemIcon>
							<LaptopIcon />
						</ListItemIcon>
						<ListItemText
							disableTypography
							primary={
								<Typography className={`${selectedIndex === 8 || selectedIndex === 9 || selectedIndex === 10 || selectedIndex === 11 ? classes.selectedItem : ''}`}>
									{intl.formatMessage({ id: 'navigation.hradmin' })}
								</Typography>
							}
						/>
						{collapseStates.hrAdmin ? <ExpandLess /> : <ExpandMore />}
					</ListItem>
					<Collapse in={collapseStates.hrAdmin} timeout="auto" unmountOnExit key="hr_admin_collapse">
						<List component="div" disablePadding>
							<ListItem 
								onClick={() => 
									handleListItemClick(10, '/employee_record_mgt')
								}
								button 
								key="employee_records_item"
								selected={selectedIndex === 10}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 10 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.employee_records' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
							<ListItem 
								onClick={() => 
									handleListItemClick(11, '/approvers_configuration')
								}
								button 
								key="approver_config_item"
								selected={selectedIndex === 11}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 11 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.approver_config' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
							<ListItem
								onClick={() =>
									handleListItemClick(8, '/ot_history')
								}
								button
								key="ot_history"
								selected={selectedIndex === 8}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 8 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.ot_history' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
							<ListItem
								onClick={() =>
									handleListItemClick(9, '/cash_out')
								}
								button
								key="cash_out"
								selected={selectedIndex === 9}
							>
								<div className={classes.subModule}>
									<ListItemText
										disableTypography
										primary={
											<Typography className={`${selectedIndex === 9 ? classes.selectedItem : ''}`}>
												{intl.formatMessage({ id: 'navigation.cash_out' })}
											</Typography>
										}
									/>
								</div>
							</ListItem>
						</List>
					</Collapse>
				</>
			)}

			<Hidden smUp>
				<ListItem onClick={handleChangeLanguage} button className={classes.nested}>
					<ListItemIcon>
						<TranslateIcon style={{ color: '#232f3e' }} />
					</ListItemIcon>
					<ListItemText primary={translate} />
				</ListItem>
			</Hidden>
		</List>
	);
}